<template>
  <!-- class="animated fadeIn" -->
  <div>
    <div class="mb-10">
      <a @click="openPage('/memberEntry?page=' + previousCurrentPage)" class="link-back">
        <i class="fas fa-arrow-circle-left mr-5"></i>Back {{ !isViewOnly }}
      </a>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row">
          <div class="col-md-3">
            <div class="font-bold">All Member Information</div>
          </div>
          <div class="col-md-9 text-right">
            <a @click="openPage('/memberEntry/editRekening?id=' + id_member)"
              class="btn-secondary pl-25 pr-25">Rekening</a>
            <a @click="openPage('/memberEntry/editCreditCard?id=' + id_member)"
              class="btn-secondary pl-25 pr-25 ml-10">Credit Card</a>
            <a @click="openPage('/memberEntry/convert?id=' + id_member)" class="btn-primary ml-10">Convert</a>
            <a @click="resetPassword()" class="btn-secondary ml-10">Reset
              Password</a>
            <a @click="openPage('/memberEntry/myPoints?id=' + id_member)" class="btn-secondary ml-10">Points</a>
            <a @click="resetMaxMobilePhoto()"
              :class="['btn-secondary ml-10', { disabled: dataMemberDetail.max_mobile_photo == 0 }]">Reset Upload
              IMG</a>
          </div>
        </div>
        <hr class="short-line left" />
        <form @submit.prevent="updateDataMember('updateScope')" data-vv-scope="updateScope">
          <div class="row">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">First Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.first_name"
                    name="first_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Last Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.last_name" name="last_name"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Sales</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="sales_id" v-model="dataMemberDetail.sales_id" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataSales" :value="item.id" :key="index">{{ item.fullname }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">RFID Card Code</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.rfid_card_code"
                    name="rfid_card_code" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Branch</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="changeBranch" name="branch_id" v-model="dataMemberDetail.branch_id"
                    class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataBranch" :value="item.id" :key="index">{{ item.name }}</option>
                  </b-form-select>
                  <!-- <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.sales_id" name="sales_id" type="text"></b-form-input> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Refferal PT</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="refferal_pt_id" v-model="dataMemberDetail.referral_pt_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Email</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.email" name="email"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Phone Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.phone_number"
                    name="phone_number" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Country Code</div>
                </b-col>
                <b-col sm="9">
                  <model-select autocomplete="false" :options="optionCountryCode" @searchchange="onCountryCode"
                    class="border-bottom" placeholder="country code" name="country_code"
                    v-model="dataMemberDetail.phone_country_code"></model-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Home Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.home_number"
                    name="home_number" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Address</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.address" name="address"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Current Address</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.current_address"
                    name="current_address" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Gender</div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group id="radios2" v-model="dataMemberDetail.gender_id" name="gender">
                    <b-form-radio class="font-13" value="1">Male</b-form-radio>
                    <b-form-radio class="font-13" value="2">Female</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Birthday</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.birthday" name="birthday"
                    class="w-100"></flat-pickr>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">ID Card</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.id_card" name="id_card"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Contact</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.emergency_contact"
                    name="emergency_contact" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Phone</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.emergency_phone"
                    name="emergency_phone" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Start Membership</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.start_membership" name="start_membership"
                    class="w-100"></flat-pickr>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Last Buy Price</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.membership_last_buy_price"
                    name="membership_last_buy_price" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership</div>
                </b-col>
                <b-col sm="9">
                  <!-- information last buy membership -->
                  <template v-if="(dataMemberDetail.membership_status_id == 4 || dataMemberDetail.membership_status_id == 5) && dataMemberDetail.membership_id == 0">
                    <b-form-input class="form-control border-bottom" v-model="membershipLastBuyName"
                    name="membershipLastBuyName" type="text" disabled></b-form-input>
                  </template>
                  <template v-else>
                    <b-form-select name="membership_id" v-model="dataMemberDetail.membership_id"
                      class="form-control border-bottom">
                      <option value="null" selected>Please select</option>
                      <option v-for="(item, index) in dataMembership" :value="item.id" :key="index">{{ item.id }}
                        {{ item.name }}</option>
                    </b-form-select>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Expired Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.membership_expired_date"
                    name="membership_expired_date" class="w-100 border-bottom"
                    @on-close="changeExpiredDate"></flat-pickr>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Next Due Payment Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.next_due_payment_date"
                    name="next_due_payment_date" class="w-100 border-bottom" :disabled="disabledNDP"></flat-pickr>
                  <span class="error" v-if="disabledNDP">You cannot edit this field</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Monthly Auto Debet Status</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="membership_monthly_auto_debet_status_id"
                    v-model="dataMemberDetail.membership_monthly_auto_debet_status_id"
                    class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataMembershipAutoDebet" :value="item.id" :key="index">{{ item.name
                    }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Banned Count</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.banned_count"
                    name="banned_count" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Banned Until Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.banned_until_date" name="banned_until_date"
                    class="w-100 border-bottom"></flat-pickr>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Source ID</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="source_id" v-model="dataMemberDetail.source_id"
                    class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataSource" :value="item.id" :key="index">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Status</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="membership_status_id" v-model="dataMemberDetail.membership_status_id"
                    class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataMembershipStatus" :value="item.id" :key="index">{{ item.name }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Freeze Until</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="config" v-model="dataMemberDetail.membership_freeze_until"
                    name="membership_freeze_until" class="w-100 border-bottom"></flat-pickr>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Membership Contract Category</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="membership_contract_category_id"
                    v-model="dataMemberDetail.membership_contract_category_id" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataMembershipContract" :value="item.id" :key="index">{{ item.name
                    }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Corporate ID</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="corporate_id" v-model="dataMemberDetail.corporate_id"
                    class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataCorporate" :value="item.id" :key="index">{{ item.name }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Corporate Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.corporate_name"
                    name="corporate_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Join Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="{
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    enableSeconds: true
                  }" v-model="dataMemberDetail.created_at" name="created_at" class="w-100 border-bottom"></flat-pickr>
                </b-col>
              </b-row>
            </div>

            <!-- Current filter for File Upload ==> v-if="dataMemberDetail.lead!==null" -->
            <div class="col-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">Selfie Photo</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="selfie_photo" @change="previewImage" accept="image/jpeg,image/png,image/jpg"
                    v-model="photo.selfie_photo" ref="selfie_photo" :state="Boolean(file)"
                    placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData.length > 0">
                      <img class="preview" :src="imageData" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('selfie')"
                        v-if="photo.selfie_update">Update Selfie</a>
                    </template>
                    <template v-else>
                      <img class="preview"
                        :src="dataMemberDetail.lead ? 'https://api.paradigmfitnessindonesia.com/crm/v1/img/leads/' + dataMemberDetail.lead.selfie_photo : ''" />
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('selfie_photo') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">ID Card Photo</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="id_card_2" @change="previewImage5" accept="image/jpeg,image/png,image/jpg" v-model="photo.ktp_photo"
                    ref="id_card_photo" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <div class="image-preview">
                    <template v-if="imageData5.length > 0">
                      <img class="preview" :src="imageData5" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('id card')"
                        v-if="photo.ktp_update">Update ID Card</a>
                    </template>
                    <template v-else>
                      <img class="preview"
                        :src="dataMemberDetail.lead ? 'https://api.paradigmfitnessindonesia.com/crm/v1/img/leads/' + dataMemberDetail.lead.ktp_photo : ''" />
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('id_card') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">Credit Card Photo</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="other_person_credit_card_photo_2" @change="previewImage6" accept="image/jpeg,image/png,image/jpg"
                    v-model="photo.credit_card_photo" ref="credit_card_photo" :state="Boolean(file)"
                    placeholder="Choose a file..."></b-form-file>
                  <div class="image-preview">
                    <template v-if="imageData6.length > 0">
                      <img class="preview" :src="imageData6" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('credit card')"
                        v-if="photo.credit_card_update">Update Credit Card</a>
                    </template>
                    <template v-else>
                      <img class="preview"
                        :src="dataMemberDetail.lead ? 'https://api.paradigmfitnessindonesia.com/crm/v1/img/leads/' + dataMemberDetail.lead.credit_card_photo : ''" />
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                </b-col>
              </b-row>

              <!-- update kartu keluarga -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">Family Card</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="other_person_family_card_photo" @change="previewImage7"
                    accept="image/*, application/pdf" v-model="photo.family_card_photo" ref="family_card_photo"
                    :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png, pdf | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData7.length > 0">
                      <img class="preview" :src="imageData7" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('family card')"
                        v-if="photo.family_card_update">Update Family Card</a>
                    </template>
                    <template v-else>
                      <template v-if="detectFileType(dataMemberDetail.lead ? dataMemberDetail.lead.family_card : '') == 'image'">
                        <img class="preview" :src="dataMemberDetail.lead ? dataMemberDetail.lead.family_card : ''" />
                      </template>
                      <!-- pdf -->
                      <template v-if="detectFileType(dataMemberDetail.lead ? dataMemberDetail.lead.family_card : '') == 'pdf'">
                        <a :href="dataMemberDetail.lead ? dataMemberDetail.lead.family_card : ''"
                          target="_blank">Preview</a>
                      </template>

                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                </b-col>
              </b-row>

              <!-- Other CC -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">Other Credit Card</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="other_credit_card_photo" @change="previewImage8" accept="image/*"
                    v-model="photo.other_credit_card_photo" ref="other_credit_card_photo" :state="Boolean(file)"
                    placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData8.length > 0">
                      <img class="preview" :src="imageData8" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('other_credt_card')"
                        v-if="photo.other_credit_card_update">Update Other Card</a>
                    </template>
                    <template v-else>
                      <img class="preview"
                        :src="dataMemberDetail.lead ? dataMemberDetail.lead.other_credit_card_photo : ''" />
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                </b-col>
              </b-row>

              <!-- Other File -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="image_blog">Other File</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file name="other_file" @change="previewImage9" accept="image/*, application/pdf"
                    v-model="photo.other_file" ref="other_file" :state="Boolean(file)"
                    placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png, pdf | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData9.length > 0">
                      <img class="preview" :src="imageData9" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('other_file')"
                        v-if="photo.other_file_update">Update Other File</a>
                    </template>
                    <template v-else>
                      <template v-if="detectFileType(dataMemberDetail.lead ? dataMemberDetail.lead.other_file : '') == 'image'">
                        <img class="preview" :src="dataMemberDetail.lead ? dataMemberDetail.lead.other_file : ''" />
                      </template>
                      <!-- pdf -->
                      <template v-if="detectFileType(dataMemberDetail.lead ? dataMemberDetail.lead.other_file : '') == 'pdf'">
                        <a :href="dataMemberDetail.lead ? dataMemberDetail.lead.other_file : ''"
                          target="_blank">Preview</a>
                      </template>
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> x -->
                </b-col>
              </b-row>
            </div>

            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Agreement</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="corporate_id" v-model="dataMemberDetail.is_agree"
                    class="form-control border-bottom">
                    <option :value="1">Yes</option>
                    <option :value="0">No</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Payment Status</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataMemberDetail.payment_status"
                    name="payment_status" type="text" readonly></b-form-input>
                </b-col>
              </b-row>
            </div>

            <!-- Pending Remarks -->
            <div class="col-12">
              <hr />
              <div class="mb-10">Pending Remarks</div>
              <textarea name="notes" v-model="dataMemberDetail.pending_remarks" class="w-100 mb-10" rows="4"></textarea>
              <!-- <span class="error">{{ errors.first('updateScope.notes') }}</span> -->
            </div>

            <div class="col-12">
              <hr />
              <div class="mb-10">Notes</div>
              <textarea name="notes" v-validate="'required'" v-model="dataMemberDetail.notes" class="w-100 mb-10"
                rows="4"></textarea>
              <span class="error">{{ errors.first('updateScope.notes') }}</span>
            </div>
          </div>
          <div class="text-right">
            <button v-if="getRoleId != '33' && !isViewOnly" type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
    <div class="title font-300 font-20 mb-15">Notes History</div>
    <div class="box">
      <div class="p-15">
        <b-table @sort-changed="sortingChanged6" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items6" :fields="fields6" :current-page="currentPage6">
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->

            <template v-if="getRoleId == '17' || getRoleId == 17">
              <b-btn @click="updateNotes(data.item.id)" size="sm" class="btn-table warning">
                <i class="fas fa-pen mr-5"></i>Edit
              </b-btn>
            </template>
            <template v-if="getRoleId == '17' || getRoleId == 17">
              <b-btn size="sm" v-on:click="deleteNote(data.item.id)" class="btn-table danger ml-5">
                <i class="fas fa-trash"></i> Delete
              </b-btn>
            </template>

            <!-- only staff -->
            <template v-if="permissionActionNotes()">
              <b-btn @click="updateNotes(data.item.id)" size="sm" class="btn-table warning">
                <i class="fas fa-pen mr-5"></i>Edit
              </b-btn>
            </template>
            <template v-if="permissionActionNotes()">
              <b-btn size="sm" v-on:click="deleteNote(data.item.id)" class="btn-table danger ml-5">
                <i class="fas fa-trash"></i> Delete
              </b-btn>
            </template>

          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage6" :total-pages="totalPage6"
          @page-changed="pageOneChanged6" prev-text="Prev" next-text="Next" />
      </div>
      <b-modal modal-class="modal-custom-image" hide-footer ref="editNotes" centered title="Edit Notes">
        <div class="p-15">
          <!--          <form @submit.prevent="submitUpdateNotes('editNotesPart')" data-vv-scope="editNotesPart">-->
          <form v-on:submit.prevent data-vv-scope="editNotesPart">
            <div class="mb-15">
              <label>Date</label>
              <div class="select-time">
                <flat-pickr :config="configDate" v-model="editNotesData.created_at" name="editDateNotes"
                  class="w-100"></flat-pickr>
              </div>
              <span class="error">{{ errors.first('editDateNotes') }}</span>
            </div>
            <div class="mb-15">
              <label>Notes</label>
              <textarea name="editNotes" v-validate="'required'" v-model="editNotesData.notes" class="w-100"
                rows="4"></textarea>
              <span class="error">{{ errors.first('editNotesPart.editNotes') }}</span>
            </div>
            <div class="text-right">
              <button v-if="getRoleId != '33' && !isViewOnly" type="button" class="btn-primary"
                @click="submitUpdateNotes('editNotesPart')">Submit</button>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
    <div class="title font-300 font-20 mb-15">Gym Attendance</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editGym?id=' + data.item.id + '&member_id=' + $route.query.id)" size="sm"
              class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <b-btn v-if="getRoleId != '33' && !isViewOnly" size="sm" v-on:click="deleteGymAttendance(data.item.id)"
              class="btn-table danger ml-5">
              <i class="fas fa-trash"></i> Delete
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <div class="title font-300 font-20 mb-15">Class Attendance</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData2)" v-model="searchData2" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged2" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items2" :fields="fields2" :current-page="currentPage2">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editClass?id=' + data.item.id + '&member_id=' + $route.query.id)" size="sm"
              class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage2" :total-pages="totalPage2"
          @page-changed="pageOneChanged2" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <div class="title font-300 font-20 mb-15">Booking History</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData3)" v-model="searchData3" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged3" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items3" :fields="fields3" :current-page="currentPage3">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editBooking?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage3" :total-pages="totalPage3"
          @page-changed="pageOneChanged3" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <div class="title font-300 font-20 mb-15">Transaction History</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData4)" v-model="searchData4" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged4" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items4" :fields="fields4" :current-page="currentPage4">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editTransaction?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <b-btn v-if="[1, 8, 2, 3, 5, 4, 6, 12, 7, 23].includes(data.item.transaction_type.id)"
              @click="sendMail(data.item.id, data.item.transaction_type.id)" size="sm"
              :disabled="activeEmailBtn.includes(data.item.id)" class="btn-table green ml-5">
              <i class="fas fa-envelope mr-5"></i>Email
            </b-btn>
            <!-- Print OR -->
            <b-btn v-if="[1, 8, 2, 3, 5, 4, 6, 12, 7, 23].includes(data.item.transaction_type.id)"
              @click="openPrintOrAndAgreement(data.item.id, data.item.transaction_type.id, 'or')" size="sm"
              :disabled="activeEmailBtn.includes(data.item.id)" class="btn-table green ml-5">
              <i class="fas fa-print mr-5"></i>OR
            </b-btn>
            <b-btn v-if="[2, 5, 6, 12].includes(data.item.transaction_type.id)"
              @click="openPrintOrAndAgreement(data.item.id, data.item.transaction_type.id, 'agr')" size="sm"
              :disabled="activeEmailBtn.includes(data.item.id)" class="btn-table green ml-5">
              <i class="fas fa-print mr-5"></i>AGR
            </b-btn>
            <b-btn
              v-if="[2, 5, 6, 7, 8, 10, 11, 12, 24].includes(data.item.transaction_type.id) && getRoleId != '33' && !isViewOnly"
              @click="checkClosingPeriodBeforeVoid(data.item.id, data.item)" size="sm"
              :disabled="activeVoidBtn.includes(data.item.id) || disableBtnSubmitTransactionHistory"
              class="btn-table danger ml-5">
              <i class="fas fa-trash"></i>
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(is_agree)="data">
            <template>
              <b-badge v-if="data.item.is_agree == 1" :variant="'success'">Success</b-badge>
              <b-badge v-if="data.item.is_agree == 0" :variant="'warning'">Waiting...</b-badge>
            </template>
          </template>
          <template v-slot:cell(status)="data">
            <!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="data.item.transaction_status_code == 200 ? 'success' : 'danger'">{{
              data.item.transaction_status_code == 200 ? 'Success' : 'Failed' }}</b-badge>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage4" :total-pages="totalPage4"
          @page-changed="pageOneChanged4" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <!-- member voucher -->
    <div class="title font-300 font-20 mb-15">Voucher History</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData4)" v-model="searchData8" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged4" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items8" :fields="fields8" :current-page="currentPage8">
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(is_used)="data">
            <!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="data.item.is_used == 1 ? 'success' : 'danger'">{{ data.item.is_used == 1 ? 'Yes' : 'No'
            }}</b-badge>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
          <template v-slot:cell(action)="data">
            <b-btn v-if="canDeleteVoucher(data.item.created_at)" size="sm" v-on:click="deleteVoucher(data.item.id)"
              class="btn-table danger ml-5">
              <i class="fas fa-trash"></i> Delete
            </b-btn>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage8" :total-pages="totalPage8"
          @page-changed="pageOneChanged4" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <!-- End Voucher -->
    <div class="title font-300 font-20 mb-15">Member PT Session</div>
    <div class="box" id="member_pt_session">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData4)" v-model="searchData4" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged5" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items5" :fields="fields5" :current-page="currentPage5">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/addPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table green ml-5">
              <i class="fas fa-plus-square mr-5"></i>Add
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(agreement)="data">
            <template v-if="data.item.transaction">
              <template v-if="data.item.transaction.is_agree == 1">
                <b-badge :variant="'success'">Success</b-badge>
              </template>
              <template v-if="data.item.transaction.is_agree == 0">
                <b-badge :variant="'warning'">Waiting...</b-badge>
              </template>
            </template>
            <template v-else>
              -
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage5" :total-pages="totalPage5"
          @page-changed="pageOneChanged5" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <!-- Banned member -->
    <div class="title font-300 font-20 mb-15">Member No Show</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData7)" v-model="searchData7" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged5" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items7" :fields="fields7" :current-page="currentPage7">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editBannedMember?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <!-- <b-btn
              @click="openPage('/memberEntry/addPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm"
              class="btn-table green ml-5"
            >
              <i class="fas fa-plus-square mr-5"></i>Add
            </b-btn> -->
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage7" :total-pages="totalPage7"
          @page-changed="pageOneChanged5" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- Member Collect Stamp -->
    <div class="row">
      <div class="col-sm-6">
        <div class="title font-300 font-20 mb-15">Member Collect Stamp</div>
      </div>
      <div class="col-sm-6 text-right">
        <a @click="openAddCollectStamp()" class="font-bold color-primary mb-10">+ Add New</a>
      </div>
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <!-- <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData7)" v-model="searchData7" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged5" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="memberCollectStampItems" :fields="memberCollectStamp"
          :current-page="currentPage7">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly" @click="openEditCollectStamp(data.item)" size="sm"
              class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <!-- <b-btn
              @click="openPage('/memberEntry/addPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm"
              class="btn-table green ml-5"
            >
              <i class="fas fa-plus-square mr-5"></i>Add
            </b-btn> -->
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage7" :total-pages="totalPage7"
          @page-changed="pageOneChanged5" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- modal add collect stamp -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'add_stamp'" centered
      title="Add Collect Stamp">
      <div class="p-10">
        <form @submit.prevent="saveCollectStamp()">
          <b-row>
            <b-col md="6">
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="addCollectStamp.collect_stamp_id"
                  class="form-control border-bottom">
                  <option value="null" selected>Please select</option>
                  <option v-for="(item, index) in masterCollectStamp" :value="item.id" :key="index">{{ item.name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="6">
              <div class="mb-10">
                <input type="number" name="point" v-model="addCollectStamp.point" class="form-control border-bottom"
                  placeholder="QTY" />
              </div>
            </b-col>
          </b-row>
          <div class="mt-5 text-right">
            <button v-if="getRoleId != '33' && !isViewOnly" type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- modal add collect stamp -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'edit_stamp'" centered
      title="Edit Collect Stamp">
      <div class="p-10">
        <form @submit.prevent="editCollectStamp()">
          <b-row>
            <b-col md="6">
              <div class="mb-10">
                <b-form-select disabled name="sales_id" v-model="addCollectStamp.collect_stamp_id"
                  class="form-control border-bottom">
                  <option value="null" selected>Please select</option>
                  <option v-for="(item, index) in masterCollectStamp" :value="item.id" :key="index">{{ item.name }}
                  </option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="6">
              <div class="mb-10">
                <input type="number" name="point" v-model="addCollectStamp.point" class="form-control border-bottom"
                  placeholder="QTY" />
              </div>
            </b-col>
          </b-row>
          <div class="mt-5 text-right">
            <button v-if="getRoleId != '33' && !isViewOnly" type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";
import { ModelSelect } from "vue-search-select";

export default {
  name: "member",
  components: {
    "app-pagination": Pagination,
    ModelSelect
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      activeEmailBtn: [],
      activeVoidBtn: [],
      disableBtnSubmitTransactionHistory: false, //disable btn submit where closing period is active
      addCollectStamp: {
        collect_stamp_id: null,
        point: 0
      },
      masterCollectStamp: [],
      selectedCollectStamp: null,
      memberCollectStampItems: [],
      memberCollectStamp: [
        {
          key: "collect_stamp.name",
          label: "Name",
          sortable: false
        },
        {
          key: "point",
          label: "Point",
          sortable: false
        },
        {
          key: "updated_at",
          label: "Created At",
          formatter: (value, key, item) => {
            return moment(item.updated_at).format("DD MMMM YYYY HH:mm a");
          },
          sortable: false
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "member.email",
          label: "Email",
          sortable: true
        },
        {
          key: "member.phone_number",
          label: "Phone Number",
          sortable: true
        },
        {
          key: "attendance_type.name",
          label: "Attendance Type",
          sortable: true
        },
        {
          key: "branch.name",
          label: "Club",
          sortable: true
        },
        {
          key: "created_at",
          label: "Attendance",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields2: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "member.email",
          label: "Email",
          sortable: true
        },
        {
          key: "member.phone_number",
          label: "Phone Number",
          sortable: true
        },
        {
          key: "classes_schedule.class.name",
          label: "Class Name",
          sortable: true
        },
        {
          key: "classes_schedule.classes_day.name",
          label: "Class Day",
          sortable: true
        },
        {
          key: "classes_schedule.classes_time.time_start",
          label: "Class Start",
          sortable: true
        },
        {
          key: "classes_schedule.classes_time.time_end",
          label: "Class End",
          sortable: true
        },
        {
          key: "classes_schedule.studio.name",
          label: "Studio",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields3: [
        {
          key: "name",
          label: "Name",
          sortable: false
        },
        {
          key: "classes_schedule.class.name",
          label: "Class Name",
          sortable: false,
          formatter: (value, key, item) => {
            if (item.pt_planner != null) {
              if (item.pt_planner.pt_planner_activity_id == 2) {
                return item.classes_schedule.class.name.replace("Session with", "PHA Appointment with")
              } else {
                return item.classes_schedule.class.name
              }
            } else {
              return item.classes_schedule ? item.classes_schedule.class.name : '-'
            }
          }
        },
        {
          key: "class_date",
          label: "Class Date",
          formatter: (value, key, item) => {
            return moment(item.class_date).format("dddd, DD MMMM YYYY");
          },
          sortable: false
        },
        {
          key: "time_class",
          label: "Class Time",
          formatter: (value, key, item) => {
            return item.classes_schedule && item.classes_schedule.classes_time
              ? item.classes_schedule.classes_time.time_start.slice(0, -3) +
              " - " +
              item.classes_schedule.classes_time.time_end.slice(0, -3)
              : "";
          },
          sortable: false
        },
        {
          key: "classes_schedule.studio.name",
          label: "Studio",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields4: [
        {
          key: "id",
          label: "TRX ID",
          sortable: true
        },
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "transaction_type.name",
          label: "Transaction Type",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "is_agree",
          label: "Agreement",
          sortable: false
        },
        {
          key: "is_agree_click_date",
          label: "Agreement Date",
          sortable: false,
          formatter: (value, key, item) => {
            return item.is_agree_click_date ? moment(item.is_agree_click_date).format("DD MMMM YYYY HH:mm") : '-';
          },
        },
        {
          key: "gross_amount",
          label: "Amount",
          formatter: (value, key, item) => {
            return (
              "Rp. " +
              item.gross_amount.toLocaleString("id-ID", {
                maximumFractionDigits: 2
              })
            );
          },
          sortable: true
        },
        {
          key: "created_at",
          label: "Time",
          formatter: (value, key, item) => {
            return moment(item.created_at).format("DD MMMM YYYY");
          },
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields5: [
        {
          key: "trx_id",
          label: "TRX ID",
          sortable: true
        },
        {
          key: "name",
          label: "Name",
          sortable: false
        },
        {
          key: "pt_session.name",
          label: "PT Session Name",
          sortable: true
        },
        // {
        //   key: 'member_pt_session_type.name',
        //   label: 'PT Session Type',
        //   sortable: false
        // },
        {
          key: "pt_session",
          label: "PT Session",
          formatter: (value, key, item) => {
            return (
              item.current_session_qty +
              " of " +
              item.buy_session_qty +
              " Sessions"
            );
          },
          sortable: true
        },
        {
          key: "personal_training.name",
          label: "PT Name",
          sortable: true
        },
        {
          key: "created_at",
          label: "Transaction Date",
          formatter: (value, key, item) => {
            return moment(item.created_at).format("DD MMMM YYYY");
          },
          sortable: true
        },
        {
          key: "expired_at",
          label: "Expired Date",
          formatter: (value, key, item) => {
            return moment(item.expired_at).format("DD MMMM YYYY");
          },
          sortable: true
        },
        {
          key: "status_session",
          label: "Status",
          formatter: (value, key, item) => {
            return item.is_active == 0
              ? "Waiting"
              : item.is_active == 1
                ? "Active"
                : item.is_active == 2
                  ? "Expired"
                  : "";
          },
          sortable: true
        },
        {
          key: "agreement",
          label: "Agreement",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields6: [
        {
          key: "created_at",
          label: "Edit Time",
          sortable: true
        },
        {
          key: "notes",
          label: "Notes",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields7: [
        {
          key: "name",
          label: "Member",
          sortable: false
        },
        {
          key: "personal_training.name",
          label: "PT Name",
          sortable: false
        },
        {
          key: "pt_no_show",
          label: "PT NoShow",
          sortable: false
        },
        {
          key: "pt_noshow_alert1_email_send",
          label: "PT NoShow Email",
          sortable: false
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields8: [
        {
          key: "id",
          label: "ID",
          sortable: true
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          formatter: (value, key, item) => {
            return item.member.first_name + ' ' + item.member.last_name
          }
        },
        {
          key: "voucher_no",
          label: "No. Voucher",
          sortable: true
        },
        {
          key: "voucher.name",
          label: "Voucher",
          sortable: true
        },
        {
          key: "voucher.description",
          label: "Voucher Desc",
          sortable: true
        },
        {
          key: "voucher_amount",
          label: "Amount",
          formatter: (value, key, item) => {
            return (
              "Rp. " +
              item.voucher_amount.toLocaleString("id-ID", {
                maximumFractionDigits: 2
              })
            );
          },
          sortable: true
        },
        {
          key: "expired_at",
          label: "Expired Date",
          formatter: (value, key, item) => {
            // revisi
            return moment(item.expired_at).format("DD MMMM YYYY");
          },
          sortable: true
        },
        {
          key: "trx_id",
          label: "Transaction ID",
          sortable: false
        },
        {
          key: "used_trx_id",
          label: "Used Transaction ID",
          sortable: false
        },
        {
          key: "is_used",
          label: "Voucher Used",
          sortable: false
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      config: {},
      configDate: {
        altInput: true,
        altFormat: "j F Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        enableSeconds: true,
        static: true,
        time_24hr: true
      },
      editNotesData: {
        notes: "",
        created_at: ""
      },
      dataSales: [],
      dataBranch: [],
      dataMembershipAutoDebet: [],
      dataMembership: [],
      dataMembershipContract: [],
      dataCorporate: [],
      dataMembershipStatus: [],
      dataSource: [],
      dataMemberDetail: {},
      dataCreditCard: {},
      membershipLastBuyName: '',
      dataMemberMembershipId: 0,
      items: [],
      items2: [],
      items3: [],
      items4: [],
      items5: [],
      items6: [],
      items7: [],
      items8: [],
      itemsPT: [],
      optionCountryCode: [],
      sortType: "",
      sortType2: "",
      sortType3: "",
      sortType4: "",
      sortType5: "",
      sortType6: "",
      sortType7: "",
      sortType8: "",
      sortBy: "",
      sortBy2: "",
      sortBy3: "",
      sortBy4: "",
      sortBy5: "",
      sortBy6: "",
      sortBy7: "",
      sortBy8: "",
      searchData: "",
      searchData2: "",
      searchData3: "",
      searchData4: "",
      searchData5: "",
      searchData6: "",
      searchData7: "",
      searchData8: "",
      previousCurrentPage: 1,
      currentPage: 1,
      currentPage2: 1,
      currentPage3: 1,
      currentPage4: 1,
      currentPage5: 1,
      currentPage6: 1,
      currentPage7: 1,
      currentPage8: 1,
      paginationLimit: 10,
      paginationLimit2: 10,
      paginationLimit3: 10,
      paginationLimit4: 10,
      paginationLimit5: 10,
      paginationLimit6: 10,
      paginationLimit7: 10,
      aginationLimit8: 10,
      totalPage: 0,
      totalPage2: 0,
      totalPage3: 0,
      totalPage4: 0,
      totalPage5: 0,
      totalPage6: 0,
      totalPage7: 0,
      totalPage8: 0,
      client_key: "Mid-client-iRIMMdeC3wQwfox5",
      idEditNotes: "",
      id_member: "",
      file: null,
      getPictureType: "takePicture",
      getPictureType5: "takePicture",
      getPictureType6: "takePicture",
      imageData: "",
      imageData5: "",
      imageData6: "",
      imageData7: "",
      imageData8: "",
      imageData9: "",
      photo: {
        selfie_photo: "",
        selfie_update: true,
        ktp_photo: "",
        ktp_update: true,
        credit_card_photo: "",
        credit_card_update: true,
        family_card_photo: "",
        family_card_update: true,
        other_credit_card_photo: "",
        other_credit_card_update: true,
        other_file: "",
        other_file_update: true
      },
      current_membership_status_id: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      user_id: Auth.Session.get().paradigm_id,
      isViewOnly: false,
      disabledNDP: true
    };
  },
  computed: {
    name() {
      return this.$route.name;
    }
  },
  methods: {
    onCountryCode(event) {
      console.log("event", event);
    },
    changeBranch(event) {
      // this.fetchData()
      axios.get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=" + this.dataMemberDetail.branch_id)
        .then((response) => {
          this.itemsPT = response.data.data.rows;
        })
    },
    saveCollectStamp() {
      const findIfExits = this.memberCollectStampItems.find(
        item => item.collect_stamp_id == this.addCollectStamp.collect_stamp_id
      )
      if (findIfExits) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Collect Stamp Already Exists!"
        })
        return
      }

      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Save it!"
        })
        .then(result => {
          if (result.value) {
            Object.assign(this.addCollectStamp, { member_id: this.$route.query.id })
            axios.post("crm/v1/member_collect_stamp", this.addCollectStamp).then(() => {
              this.$refs['add_stamp'].hide();
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: "Collect Stamp Saved",
                timer: 1500
              })
              axios.get('crm/v1/member_collect_stamp/my_collect?member_id=' + this.$route.query.id)
                .then(response => {
                  this.memberCollectStampItems = response.data.data
                  // console.log('test', response.data.data.rows)
                })
                .catch(error => {
                  console.log('error', error)
                })


            }).catch(error => {
              console.log('error', error)
            })
          }
        })
    },
    editCollectStamp() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Save it!"
        })
        .then(result => {
          if (result.value) {
            axios.put("crm/v1/member_collect_stamp/" + this.selectedCollectStamp.id, this.addCollectStamp).then(response => {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: "Collect Stamp Saved",
                timer: 1500
              })
              // hide modal
              this.$refs['edit_stamp'].hide();
              axios.get('crm/v1/member_collect_stamp/my_collect?member_id=' + this.$route.query.id)
                .then(response => {
                  this.memberCollectStampItems = response.data.data
                })
                .catch(error => {
                  console.log('error', error)
                })

            }).catch(() => {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!"
              })
            })
          }
        })
    },
    openAddCollectStamp() {
      this.addCollectStamp.collect_stamp_id = null
      this.addCollectStamp.point = 0
      this.showModal("add_stamp")
    },
    openEditCollectStamp(data) {
      this.selectedCollectStamp = data
      console.log('Selected data', data)
      this.addCollectStamp.collect_stamp_id = data.collect_stamp_id
      this.addCollectStamp.point = data.point
      this.showModal("edit_stamp")
    },
    openPrintOrAndAgreement(id, transaction_type_id, type_form) {
      this.loadingActive = true
      let keyname;
      var setTypeForm = ''
      if (type_form == 'or') {
        setTypeForm = '?is_print_or=1'
      } else {
        if (transaction_type_id == 6 || transaction_type_id == 12 || transaction_type_id == 5 || transaction_type_id == 2) {
          setTypeForm = '?is_print_agr=1'
        }
      }
      switch (transaction_type_id) {
        case 1:
          keyname = "send_invoice_buy_package" + setTypeForm;
          setTypeForm = '?is_print_or=1'
          break;
        case 2:
          keyname = "send_invoice_buy_membership" + setTypeForm;
          break;
        case 3:
          keyname = "send_invoice_auto_debet_success" + setTypeForm;
          break;
        case 4:
          keyname = "send_invoice_auto_debet_success" + setTypeForm;
          break;
        case 7:
          keyname = "send_invoice_auto_debet_success" + setTypeForm;
          break;
        case 5:
          keyname = "send_invoice_pt_session" + setTypeForm;
          break;
        case 6:
          keyname = "send_invoice_freeze" + setTypeForm;
          break;
        case 8:
          keyname = "send_invoice_outstanding" + setTypeForm;
          break;
        case 12:
          keyname = "send_invoice_buy_membership" + setTypeForm;
          break;
        case 23:
          keyname = "send_invoice_auto_collection" + setTypeForm;
          break;
        default:
      }
      var options = "location=yes,height=970,width=820,scrollbars=yes,status=yes"
      let data = { trx_id: id };
      axios
        .post("transaction/v1/transaction/" + keyname, data)
        .then(response => {
          const path = `${Auth.apiUrl}transaction/v1/img/${response.data.path}`
          setTimeout(() => {
            this.loadingActive = false
            window.open(path, '_blank', options)
          }, 3000);
        })
        .catch(error => {
          this.loadingActive = false
          console.error("error", error);
        });
      return
    },
    changeExpiredDate(ev) {
      const today = moment().format("YYYY-MM-DD")
      const selected = moment(ev[0]).format("YYYY-MM-DD")
      if (today > selected) {
        this.dataMemberDetail.membership_status_id = 5
      } else {
        this.dataMemberDetail.membership_status_id = this.current_membership_status_id
      }
    },
    drawCanvas(canvas, img) {
      canvas.width = getComputedStyle(canvas).width.split("px")[0];
      canvas.height = getComputedStyle(canvas).height.split("px")[0];
      let ratio = Math.min(
        canvas.width / img.width,
        canvas.height / img.height
      );
      let x = (canvas.width - img.width * ratio) / 2;
      let y = (canvas.height - img.height * ratio) / 2;
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
      canvas
        .getContext("2d")
        .drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          x,
          y,
          img.width * ratio,
          img.height * ratio
        );
    },
    drawCanvas5(canvas5, img5) {
      canvas5.width = getComputedStyle(canvas5).width.split("px")[0];
      canvas5.height = getComputedStyle(canvas5).height.split("px")[0];
      let ratio = Math.min(
        canvas5.width / img5.width,
        canvas5.height / img5.height
      );
      let x = (canvas5.width - img5.width * ratio) / 2;
      let y = (canvas5.height - img5.height * ratio) / 2;
      canvas5.getContext("2d").clearRect(0, 0, canvas5.width, canvas5.height);
      canvas5
        .getContext("2d")
        .drawImage(
          img5,
          0,
          0,
          img5.width,
          img5.height,
          x,
          y,
          img5.width * ratio,
          img5.height * ratio
        );
    },
    drawCanvas6(canvas6, img6) {
      canvas6.width = getComputedStyle(canvas6).width.split("px")[0];
      canvas6.height = getComputedStyle(canvas6).height.split("px")[0];
      let ratio = Math.min(
        canvas6.width / img6.width,
        canvas6.height / img6.height
      );
      let x = (canvas6.width - img6.width * ratio) / 2;
      let y = (canvas6.height - img6.height * ratio) / 2;
      canvas6.getContext("2d").clearRect(0, 0, canvas6.width, canvas6.height);
      canvas6
        .getContext("2d")
        .drawImage(
          img6,
          0,
          0,
          img6.width,
          img6.height,
          x,
          y,
          img6.width * ratio,
          img6.height * ratio
        );
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage5: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData5 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage6: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData6 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage7: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData7 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage8: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData8 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage9: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData9 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sendMail(id, transaction_type_id) {
      console.log(transaction_type_id)
      this.$swal({
        title: "Confirm?",
        text: "You will send invoice for this transaction!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Send it!",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.activeEmailBtn.push(id);
          let keyname;
          switch (transaction_type_id) {
            case 1:
              keyname = "send_invoice_buy_package";
              break;
            case 2:
              keyname = "send_invoice_buy_membership";
              break;
            case 3:
              keyname = "send_invoice_auto_debet_success";
              break;
            case 4:
              keyname = "send_invoice_auto_debet_success";
              break;
            case 7:
              keyname = "send_invoice_cancellation";
              break;
            case 5:
              keyname = "send_invoice_pt_session";
              break;
            case 6:
              keyname = "send_invoice_freeze";
              break;
            case 8:
              keyname = "send_invoice_outstanding";
              break;
            case 12:
              keyname = "send_invoice_buy_membership";
              break;
            case 23:
              keyname = "send_invoice_auto_collection";
              break;
            default:
          }
          let data = { trx_id: id };
          axios
            .post("transaction/v1/transaction/" + keyname, data)
            .then(response => {
              this.activeEmailBtn = this.activeEmailBtn.filter(e => e !== id);
              this.$swal(
                "Email sent",
                "You successfully sent email",
                "success"
              );
            })
            .catch(error => {
              this.activeEmailBtn = this.activeEmailBtn.filter(e => e !== id);
              this.$swal(
                "Error",
                "There is an aerror when sending email",
                "error"
              );
              console.log("error", error);
            });
        } else {
          this.$swal(
            "Cancelled",
            "You have cancelled to sending email",
            "info"
          );
        }
      });
      return;
    },
    checkClosingPeriodBeforeVoid(id, item) {
      this.loadingActive = true
      console.log('item', item)
      const year = moment(item.created_at).format('YYYY')
      const month = moment(item.created_at).format('M')

      axios.get('crm/v1/closing_period/member_pt_session?year=' + year + '&bulan=' + month).then(response => {
        this.loadingActive = false
        this.$swal(
          "Error",
          "You can't void this transaction, cause closing period is already closed!",
          "error"
        );
      }).catch(error => {
        this.loadingActive = false
        // this.disabledExpiredDate = false
        console.log('error', error)
        this.voidTransaction(id)
      })
    },
    voidTransaction(id) {
      this.$swal({
        title: "Confirm?",
        text: "You will delete this transaction!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Send it!",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.activeVoidBtn.push(id);
          axios
            .delete("transaction/v1/transaction/" + id)
            .then(response => {
              this.activeVoidBtn = this.activeVoidBtn.filter(e => e !== id);
              this.$swal(
                "Deleted Data",
                "You successfully delete this data",
                "success"
              );
              this.fetchData();
            })
            .catch(error => {
              this.activeVoidBtn = this.activeVoidBtn.filter(e => e !== id);
              this.$swal(
                "Error",
                "There is an error when deleting data",
                "error"
              );
              console.log("error", error);
            });
        } else {
          this.$swal(
            "Cancelled",
            "You have cancelled to deleting this data",
            "info"
          );
        }
      });
      return;
    },
    updateNotes(id) {
      this.idEditNotes = id;
      this.$refs["editNotes"].show();
      axios
        .get(
          "fitness/v1/member_notes/single/" + id + "?v=" + new Date().getTime()
        )
        .then(response => {
          console.log(response.data.data);
          this.editNotesData.notes = response.data.data.notes;
          this.editNotesData.created_at = response.data.data.created_at;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    submitUpdateNotes(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          // console.log('put data', this.editNotesData)
          axios
            .put(
              "fitness/v1/member_notes/" + this.idEditNotes,
              this.editNotesData
            )
            .then(response => {
              // console.log('test', response)
              this.fetchData();
              this.$refs["editNotes"].hide();
              // this.$router.push('/memberEntry/edit?id=' + this.$route.query.id)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    updateDataMember(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          let membershipList = this.dataMembership;
          for (let i = 0; i < membershipList.length; i++) {
            if (membershipList[i].id == this.dataMemberDetail.membership_id) {
              if (
                this.dataMemberMembershipId !=
                this.dataMemberDetail.membership_id
              ) {
                this.dataMemberDetail.membership_last_buy_name =
                  membershipList[i].name;
                this.dataMemberDetail.membership_last_buy_price =
                  membershipList[i].price;
                break;
              }
            }
          }

          let data1 = this.dataMemberDetail;
          let data2 = Object.assign({}, data1);
          delete data2.id;
          delete data2.branch;
          delete data2.gender;
          delete data2.source;
          this.dataMemberDetail = data2;

          const payload = {
            member_id: this.$route.query.id,
            request_data: this.dataMemberDetail,
            action: 'EDIT',
            notes: 'Update Data Member',
            description: `Update data member with name ${this.dataMemberDetail.first_name} ${this.dataMemberDetail.last_name} | notes: ${this.dataMemberDetail.notes} `,
          }

          // this.loadingActive = true
          // add to approval request
          axios.post('crm/v1/approval_request/module_member', payload).then(response => {
            this.loadingActive = false
            console.log('Approval', response.data)
            // this.$swal('Successfully!', 'Data has been submitted and waiting for approval!', 'success')
          }).catch((error) => {
            this.loadingActive = false
            console.log('Error', error)
            // this.$swal('Failed!', 'Data has been waiting for approval!', 'error')
          })

          // remark when approval future is ready
          axios
            .put(
              "fitness/v1/member/" + this.$route.query.id,
              this.dataMemberDetail
            )
            .then(response => {
              // console.log('test', response)
              // this.$router.push("/memberEntry");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.fetchData();

            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    parseDate(value) {
      return moment(value).format("DD MMMM YYYY HH:mm");
      // return moment(value).format('DD MMMM YYYY, HH:MM')
    },
    // part all paginate and sort
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    pageOneChanged2(pageNum) {
      this.currentPage2 = pageNum;
      this.fetchData();
    },
    pageOneChanged3(pageNum) {
      this.currentPage3 = pageNum;
      this.fetchData();
    },
    pageOneChanged4(pageNum) {
      this.currentPage4 = pageNum;
      this.fetchData();
    },
    pageOneChanged5(pageNum) {
      this.currentPage5 = pageNum;
      this.fetchData();
    },
    pageOneChanged6(pageNum) {
      this.currentPage6 = pageNum;
      this.fetchData();
    },
    pageOneChanged7(pageNum) {
      this.currentPage7 = pageNum;
      this.fetchData();
    },
    pageOneChanged8(pageNum) {
      this.currentPage8 = pageNum;
      this.fetchData();
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged2(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy2 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType2 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType2 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged3(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy3 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType3 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType3 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged4(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy4 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType4 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType4 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged5(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy5 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType5 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType5 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged6(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy6 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType6 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType6 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
          ? "danger"
          : status === "active"
            ? "success"
            : status === "inactive"
              ? "danger"
              : "primary";
    },
    parseImg(value) {
      return Auth.apiUrl + "fitness/v1/img/member/" + value;
    },
    getRowCount(items) {
      return items.length;
    },
    openPage(event) {
      this.$router.push(event);
    },
    resetPassword() {
      this.$swal({
        title: "Are you sure?",
        text: "to Reset this Password?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Reset now!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          var _reseting_pass = {
            member_id: this.$route.query.id
          }
          axios
            .post("vendor/v1/auth/user/reset_password", _reseting_pass)
            .then(response => {
              this.$swal(
                "Success",
                "Password Successfully changed!",
                "success"
              );
              // this.$router.go()
              this.fetchData();
            })
            .catch(error => {
              console.log("error", error);
              this.$swal("Something wrong!", "Please Try Again!", "warning");
            });
        } else {
          this.$swal("Cancelled", "Canceled!", "info");
        }
      });
    },
    resetMaxMobilePhoto() {
      if (this.dataMemberDetail.max_mobile_photo == 0) return;
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to reset Max Upload Image for this member?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reset now!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          axios
            .post("fitness/v1/member/reset_max_mobile_photo", {
              member_id: this.$route.query.id
            })
            .then(response => {
              this.dataMemberDetail.max_mobile_photo = 0;
              this.$swal("Success", "Max Upload Image has been reset!", "success");
            })
            .catch(error => {
              console.log("error", error);
              this.$swal("Something wrong!", "Please Try Again!", "warning");
            });
        } else {
          this.$swal("Cancelled", "Canceled!", "info");
        }
      });
    },
    editBlogCategory(event) {
      this.$router.push(event);
    },
    detectFileType(url) {
      if (!url || typeof url !== 'string') return null;

      const lowerUrl = url.toLowerCase();

      if (/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/.test(lowerUrl)) {
        return 'image';
      } else if (/\.(pdf)$/.test(lowerUrl)) {
        return 'pdf';
      } else {
        return 'unknown';
      }
    },
    permissionActionNotes() {
      const users = [1071841, 1071846, 511, 1, 1071844]

      if (users.includes(Number(Auth.Session.get().paradigm_id))) {
        return true
      } else {
        return false
      }
    },
    updateLeadsPhoto(type) {
      this.loadingActive = true
      // const formData = new FormData();
      if (type === "selfie") {
        const formDataSelfie = new FormData();
        const formDataSelfieS3 = new FormData();
        formDataSelfie.append("selfie_photo", this.photo.selfie_photo);
        formDataSelfieS3.append("file", this.photo.selfie_photo);
        formDataSelfieS3.append("prefix", `SELFIE-${this.$route.query.id}-`);

        // add first to s3
        axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataSelfieS3)
          .then(resp => {
            console.log("Photo selfie uploaded to s3", resp);

            // upload to crm
            formDataSelfie.append("s3url_selfie_photo", resp.data.data.location);
            axios
              .put("crm/v1/leads/" + this.dataMemberDetail.lead.id, formDataSelfie)
              .then(response => {
                this.loadingActive = false
                this.photo.selfie_photo = "";
                this.photo.selfie_update = false;

                axios.put("fitness/v1/member/manual/change_photo_selfie/" + this.$route.query.id, formDataSelfie)
                  .then(res => {
                    console.log("Photo selfie updated", res);
                  }).catch(error => {
                    console.error("Photo selfie error", error);
                  })

                this.$swal(
                  "Success",
                  "Your have successfully update Selfie Photo",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });

          }).catch(error => {
            this.loadingActive = false
            console.error("Photo selfie error to s3", error);
          })
      }
      if (type === "id card") {
        const formDataIdCard = new FormData();
        const formDataIdCardS3 = new FormData();
        formDataIdCard.append("ktp_photo", this.photo.ktp_photo);

        formDataIdCardS3.append("file", this.photo.ktp_photo);
        formDataIdCardS3.append("prefix", `KTP-${this.$route.query.id}-`);

        // add first to s3
        axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataIdCardS3)
          .then(resp => {
            console.log("Photo ktp_photo uploaded to s3", resp);

            // upload to crm
            formDataIdCard.append("s3url_ktp_photo", resp.data.data.location);
            axios
              .put("crm/v1/leads/" + this.dataMemberDetail.lead.id, formDataIdCard)
              .then(response => {
                this.loadingActive = false
                this.photo.ktp_photo = "";
                this.photo.ktp_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update ID Card Photo",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });

          }).catch(error => {
            this.loadingActive = false
            console.error("Photo ktp_photo error to s3", error);
          })
      }
      if (type === "credit card") {
        const formDataCC = new FormData();
        const formDataCCS3 = new FormData();
        formDataCC.append("credit_card_photo", this.photo.credit_card_photo);

        // upload to s3
        formDataCCS3.append("file", this.photo.credit_card_photo);
        formDataCCS3.append("prefix", `CCPhoto-${this.$route.query.id}-`);

        // add first to s3
        axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataCCS3)
          .then(resp => {
            console.log("Photo credit_card_photo uploaded to s3", resp);

            // upload to crm
            formDataCC.append("s3url_credit_card_photo", resp.data.data.location);
            axios
              .put("crm/v1/leads/" + this.dataMemberDetail.lead.id, formDataCC)
              .then(response => {
                this.loadingActive = false
                this.photo.credit_card_photo = "";
                this.photo.credit_card_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Credit Card Photo",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });

          }).catch(error => {
            this.loadingActive = false
            console.error("Photo credit_card_photo error to s3", error);
          })
      }

      if (type === "family card") {
        const formDataFC = new FormData();
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formDataFC.append("file", this.photo.family_card_photo);
        axios
          .post("storage/upload", formDataFC)
          .then(response => {
            this.loadingActive = false
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            // console.log(response);
            const family_card_photo = {
              family_card: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.dataMemberDetail.lead.id, family_card_photo).then(response => {
                this.loadingActive = false
                this.photo.family_card_photo = "";
                this.photo.family_card_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Family Card Photo",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });
          })
          .catch(error => {
            this.loadingActive = false
            console.log(error);
          });
      }

      if (type === "other_credt_card") {
        const formDataOCC = new FormData();
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formDataOCC.append("file", this.photo.other_credit_card_photo);
        axios
          .post("storage/upload", formDataOCC)
          .then(response => {
            this.loadingActive = false
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            const upload_other_file = {
              other_credit_card_photo: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.dataMemberDetail.lead.id, upload_other_file).then(response => {
                this.loadingActive = false
                this.photo.other_credit_card_photo = "";
                this.photo.other_credit_card_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Other Credit Card",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });
          })
          .catch(error => {
            this.loadingActive = false
            console.log(error);
          });
      }

      if (type === "other_file") {
        const formDataOF = new FormData();
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formDataOF.append("file", this.photo.other_file);
        axios
          .post("storage/upload", formDataOF)
          .then(response => {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            const otherfile = {
              other_file: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.dataMemberDetail.lead.id, otherfile).then(response => {
                this.loadingActive = false
                this.photo.other_file = "";
                this.photo.other_file_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Other File!",
                  "success"
                );
              })
              .catch(error => {
                this.loadingActive = false
                console.log(error);
              });
          })
          .catch(error => {
            this.loadingActive = false
            console.log(error);
          });
      }
    },
    showModal(id) {
      this.$refs[id].show();
    },
    deleteGymAttendance(id) {
      // console.log(id)
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          axios.delete('fitness/v1/member_gym_attendance/' + id).then(response => {
            this.$swal(
              "Deleted",
              "You successfully deleted this file",
              "success"
            );
            this.fetchData();
          }).catch(error => {
            console.log("error", error);
          });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      })
    },
    deleteNote(event) {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
          axios
            .delete("fitness/v1/member_notes/" + event)
            .then(response => {
              // this.$router.go()
              this.fetchData();
            })
            .catch(error => {
              console.log("error", error);
            });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    canDeleteVoucher(createdAt) {
      return moment(createdAt).isSameOrAfter(moment().subtract(1, "days").startOf("day"));
    },
    deleteVoucher(event) {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          axios
            .delete("crm/v1/member_voucher/" + event)
            .then(response => {
              this.$swal(
                "Deleted",
                "You successfully deleted this voucher",
                "success"
              );
              this.fetchData();
            })
            .catch(error => {
              console.log("error", error);
              this.$swal("Failed", "Can't delete this voucher", "error");
            });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    fetchData() {
      // axios.get('fitness/v1/member?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
      //   this.items = response.data.data.rows
      //   this.totalPage = response.data.meta.pageCount
      //   // console.log('test', response.data.data.rows)
      // }).catch(error => {
      //   console.log('error', error)
      // })




      axios.get('crm/v1/collect_stamp?page=&limit=')
        .then(response => {
          this.masterCollectStamp = response.data.data.rows
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log('error', error)
        })
      axios.get('crm/v1/member_collect_stamp/my_collect?member_id=' + this.$route.query.id)
        .then(response => {
          this.memberCollectStampItems = response.data.data
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log('error', error)
        })
      axios
        .get("fitness/v1/branch/")
        .then(response => {
          this.dataBranch = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/sales?sorting=fullname&sorting_type=asc")
        .then(response => {
          this.dataSales = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/member/" + this.$route.query.id)
        .then(response => {
          this.dataMemberDetail = response.data.data;
          if (!this.dataMemberDetail.phone_country_code) {
            this.dataMemberDetail.phone_country_code = "+62"; // default ID (Indonesia) kalau null dari backend
          }
          this.dataMemberMembershipId = this.dataMemberDetail.membership_id;
          this.current_membership_status_id = this.dataMemberDetail.membership_status_id
          // console.log('test', response.data.data)
          this.membershipLastBuyName = this.dataMemberDetail.membership_last_buy_name
          axios.get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=" + this.dataMemberDetail.branch_id)
            .then((response) => {
              this.itemsPT = response.data.data.rows;
            })
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/country_code")
        .then(response => {
          this.optionCountryCode = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const el = response.data.data[i];
            this.optionCountryCode.push({
              value: el.dial_codes,
              text: el.dial_codes + "  " + el.emoji + " " + el.name
            });
          }
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_source_type/")
        .then(response => {
          this.dataSource = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/membership_status/")
        .then(response => {
          this.dataMembershipStatus = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/membership_contract_category/")
        .then(response => {
          this.dataMembershipContract = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("compro/v1/corporate/")
        .then(response => {
          this.dataCorporate = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/membership/")
        .then(response => {
          this.dataMembership = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/membership_auto_debet_status/")
        .then(response => {
          this.dataMembershipAutoDebet = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      // section all table
      axios
        .get(
          "fitness/v1/history/gym_attendance?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage +
          "&limit=" +
          this.paginationLimit +
          "&sorting=" +
          this.sortBy +
          "&sorting_type=" +
          this.sortType +
          "&keyword=" +
          this.searchData
        )
        .then(response => {
          this.items = response.data.data.rows;
          this.totalPage = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "fitness/v1/history/class_attendance?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage2 +
          "&limit=" +
          this.paginationLimit2 +
          "&sorting=" +
          this.sortBy2 +
          "&sorting_type=" +
          this.sortType2 +
          "&keyword=" +
          this.searchData2
        )
        .then(response => {
          this.items2 = response.data.data.rows;
          this.totalPage2 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "fitness/v1/history/booking_history?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage3 +
          "&limit=" +
          this.paginationLimit3 +
          "&sorting=" +
          this.sortBy3 +
          "&sorting_type=" +
          this.sortType3 +
          "&keyword=" +
          this.searchData3
        )
        .then(response => {
          this.items3 = response.data.data.rows;
          this.totalPage3 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "fitness/v1/history/payment_history?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage4 +
          "&limit=" +
          this.paginationLimit4 +
          "&sorting=" +
          this.sortBy4 +
          "&sorting_type=" +
          this.sortType4 +
          "&keyword=" +
          this.searchData4
        )
        .then(response => {
          this.items4 = response.data.data.rows;
          this.totalPage4 = response.data.meta.pageCount;
          // console.log('test 4', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      // member voucher
      axios.get(
        "crm/v1/member_voucher?member_id=" +
        this.$route.query.id +
        "&page=" +
        this.currentPage8 +
        "&limit=" +
        this.paginationLimit8 +
        "&sorting=" +
        this.sortBy8 +
        "&sorting_type=" +
        this.sortType8 +
        "&keyword=" +
        this.searchData8
      )
        .then(response => {
          this.items8 = response.data.data.rows;
          this.totalPage8 = response.data.meta.pageCount;
          // console.log('test 4', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get(
          "fitness/v1/member_pt_session?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage5 +
          "&limit=" +
          this.paginationLimit5 +
          "&sorting=" +
          this.sortBy5 +
          "&sorting_type=" +
          this.sortType5 +
          "&keyword=" +
          this.searchData5 +
          "&v=" +
          new Date()
        )
        .then(response => {
          this.items5 = response.data.data.rows;
          this.totalPage5 = response.data.meta.pageCount;
        })
        .catch(error => {
          console.log("error", error);
        });
      // pt no show
      axios.get(
        "fitness/v1/member/data_entry/table/member/banned?member_id=" +
        this.$route.query.id +
        "&page=" +
        this.currentPage7 +
        "&limit=" +
        this.paginationLimit7 +
        "&sorting=" +
        this.sortBy7 +
        "&sorting_type=" +
        this.sortType7 +
        "&keyword=" +
        this.searchData7 +
        "&v=" +
        new Date()
      )
        .then(response => {
          this.items7 = response.data.data.rows;
          this.totalPage7 = response.data.meta.pageCount;
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get(
          "fitness/v1/member_notes/" +
          this.$route.query.id +
          "&page=" +
          this.currentPage6 +
          "&limit=" +
          this.paginationLimit6 +
          "&sorting=" +
          this.sortBy6 +
          "&sorting_type=" +
          this.sortType6 +
          "&keyword=" +
          this.searchData6 +
          "&v=" +
          new Date().getTime()
        )
        .then(response => {
          this.items6 = response.data.data.rows;
          this.totalPage6 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    let pageParams = urlParams.get("page");
    this.previousCurrentPage = pageParams != null ? parseInt(pageParams) : 1;
    this.id_member = this.$route.query.id;
    this.fetchData();
    if (this.$route.query.convertMembership === "true") {
      this.fetchData();
    }
    // role access
    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
    const availRoles = [1, 4, 34, 35]
    if (isclbManager.includes(8) || availRoles.includes(Number(Auth.Session.get().paradigm_role))) {
      this.disabledNDP = false
    }
  }
};
</script>

<style></style>
